// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import cookies from "vue-cookies";
import VueMeta from 'vue-meta';
import { isLogin, toLogin } from './utils/common';



Vue.use(ElementUI);
Vue.use(cookies);
Vue.use(VueMeta);

Vue.config.productionTip = false

// 路由守护
router.beforeEach((to, from, next) => {
  // -----------处理登录回调逻辑-----------------
  var account_code = to.query.code;
  if (account_code && account_code != '') {
    localStorage.setItem('account_code', account_code);
    // 移除code重新加载页面
    const { code, ...queryWithoutCode } = to.query;
    var pathWithoutCode = to.path;
    var urlParams = new URLSearchParams(queryWithoutCode).toString();
    if (urlParams != '') {
      pathWithoutCode += '?' + urlParams;
    }
    // 重新刷新页面
    window.location.href = pathWithoutCode;
    // -----------登录回调逻辑结束-----------------
  } else if (localStorage.getItem("account_code") == undefined || localStorage.getItem("account_code") == "") {
    // 强登录路由
    if (!isLogin() && to.path == '/chat_room') {
      toLogin();
    }
  }else{
    console.log('come in here');
  }

  // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
  next();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js